import { render, staticRenderFns } from "./DataFormat.vue?vue&type=template&id=49513653&scoped=true"
import script from "./DataFormat.vue?vue&type=script&lang=js"
export * from "./DataFormat.vue?vue&type=script&lang=js"
import style0 from "./DataFormat.vue?vue&type=style&index=0&id=49513653&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49513653",
  null
  
)

export default component.exports